import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_afc4fae4-3e91-49c0-b442-1e22d639f2c6/artifacts/5tm3hua0_Logo%20PF%402x.png";

const LegalPage = () => {
  const [content, setContent] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [contentRes, settingsRes] = await Promise.all([
          axios.get(`${API}/content/legal`),
          axios.get(`${API}/settings`)
        ]);
        setContent(contentRes.data);
        setSettings(settingsRes.data);
      } catch (error) {
        console.error('Error fetching legal content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600 font-inter">Chargement...</p>
        </div>
      </div>
    );
  }

  const extra = content?.extra_fields || {};

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Place Financière BFC" className="h-10" />
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-[#1e3a8a] hover:text-[#172554] font-inter text-sm transition-colors"
            >
              <ArrowLeft size={16} />
              Retour au site
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-playfair text-4xl font-bold text-[#0F172A] mb-8">
          {content?.title || 'Mentions légales'}
        </h1>

        <div className="prose prose-lg max-w-none font-inter text-slate-600">
          {/* Éditeur du site */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section1_title || 'Éditeur du site'}
            </h2>
            <div className="whitespace-pre-line">
              {extra.section1_content || `Le présent site est édité par :
Place Financière Bourgogne-Franche-Comté
Association loi 1901
Siège social : 2 avenue de Marbotte 21000 Dijon – France
SIREN : 837 672 914
Adresse e-mail : contact@placefinanciere-bfc.fr
Téléphone : 03 80 48 25 52

Directeur de la publication : Le Président de l'association Place Financière Bourgogne-Franche-Comté.`}
            </div>
          </section>

          {/* Hébergement du site */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section2_title || 'Hébergement du site'}
            </h2>
            <div className="whitespace-pre-line">
              {extra.section2_content || `Le site est hébergé par :
[Nom de l'hébergeur]
[Adresse de l'hébergeur]
[Téléphone de l'hébergeur]
[Site internet de l'hébergeur]`}
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section3_title || 'Propriété intellectuelle'}
            </h2>
            <p>
              {extra.section3_content || `L'ensemble des éléments présents sur ce site, notamment les textes, images, illustrations, logos, graphismes, icônes, vidéos, ainsi que leur mise en forme, sont la propriété exclusive de la Place Financière Bourgogne-Franche-Comté ou font l'objet d'une autorisation d'utilisation. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de la Place Financière Bourgogne-Franche-Comté. Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient pourra être considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions du Code de la propriété intellectuelle.`}
            </p>
          </section>

          {/* Responsabilité */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section4_title || 'Responsabilité'}
            </h2>
            <p>
              {extra.section4_content || `La Place Financière Bourgogne-Franche-Comté s'efforce de fournir sur ce site des informations aussi précises que possible. Toutefois, elle ne saurait être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour des informations. Les informations diffusées sur ce site sont fournies à titre indicatif et peuvent évoluer à tout moment. La Place Financière Bourgogne-Franche-Comté ne pourra être tenue responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site.`}
            </p>
          </section>

          {/* Liens hypertextes */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section5_title || 'Liens hypertextes'}
            </h2>
            <p>
              {extra.section5_content || `Le site peut contenir des liens hypertextes vers d'autres sites internet. La Place Financière Bourgogne-Franche-Comté n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu. La mise en place de liens hypertextes vers tout ou partie du site est autorisée sous réserve de ne pas porter atteinte à l'image de la Place Financière Bourgogne-Franche-Comté et de mentionner clairement la source.`}
            </p>
          </section>

          {/* Protection des données personnelles */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section6_title || 'Protection des données personnelles'}
            </h2>
            <p>
              {extra.section6_content || `Les informations éventuellement recueillies via les formulaires du site sont destinées exclusivement à la Place Financière Bourgogne-Franche-Comté afin de répondre aux demandes adressées par les utilisateurs. Les données collectées ne sont en aucun cas cédées, louées ou transmises à des tiers. Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition concernant les données vous concernant. Vous pouvez exercer ces droits en adressant votre demande à : contact@placefinanciere-bfc.fr`}
            </p>
          </section>

          {/* Cookies */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section7_title || 'Cookies'}
            </h2>
            <p>
              {extra.section7_content || `Le site peut être amené à utiliser des cookies afin d'améliorer l'expérience utilisateur et de réaliser des statistiques de fréquentation. L'utilisateur peut à tout moment configurer son navigateur afin de refuser les cookies.`}
            </p>
          </section>

          {/* Droit applicable */}
          <section className="mb-8">
            <h2 className="font-playfair text-2xl font-semibold text-[#0F172A] mb-4">
              {extra.section8_title || 'Droit applicable'}
            </h2>
            <p>
              {extra.section8_content || `Le présent site est soumis au droit français. Tout litige relatif à son utilisation sera soumis à la compétence des tribunaux français.`}
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-slate-500 font-inter">
            © {new Date().getFullYear()} Place Financière Bourgogne-Franche-Comté. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LegalPage;
